import { useContext } from "react"
import { MockAuthContext } from "services/auth/authmock/provider"

export const useMockAuth = () => {
    return useContext(MockAuthContext)

}